import { DataBannerTypes } from "@/types/BannerType";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import ArrowLeft from "@/components/Svg/ArrowLeft";

function TwoBannerTye6({ dataTemplate }: DataBannerTypes) {
  const twoBannerLink = ` rounded-[0.75rem]  sm:rounded-[1.5rem]  lg:rounded-3xl relative  overflow-hidden`;
  const twoBannerImageClass = `w-full h-full object-cover rounded-[0.75rem] sm:rounded-[1.5rem] lg:rounded-3xl absolute inset-0 hover:filter z-20 hover:blur-[2px] transition-all duration-300`;
  const twoBannerParentSpan = `absolute bottom-0 flex  items-end justify-center z-30  w-full rounded-b-2xl lg:rounded-b-3xl  h-max text-white md:text-base sm:text-base text-xs lg:text-xl`;
  const twoBannerSpan = `lg:p-6 p-4  text-right  flex  items-center gap-2 lg:gap-6    w-full bg-gradient-to-t z-30 from-[#1A1818] to-transparent `;
  const twoBannerArrow = `stroke-[#FFC20A]`;
  return (
    <div
      className={`grid  md:grid-cols-[78%,20%] grid-cols-1 gap-3 xl:gap-10 my-5 lg:my-5 lg:px-16 px-6 `}
    >
      <Link
        href={dataTemplate?.[0]?.link ?? "/"}
        style={{ order: Number(dataTemplate?.[0]?.positionInTemplate) }}
        className={`${twoBannerLink} pt-[25%]`}
      >
        <Image
          priority
          fetchPriority="high"
          sizes="100vw"
          unoptimized
          src={dataTemplate?.[0]?.patchImage ?? "/images/default.png"}
          quality={100}
          width={5000}
          height={3000}
          className={twoBannerImageClass}
          alt={`banner-1`}
        />
        <span className={twoBannerParentSpan}>
          <span className={twoBannerSpan}>
            {dataTemplate?.[0]?.title}
            <ArrowLeft className={twoBannerArrow} />
          </span>
        </span>
      </Link>
      <Link
        href={dataTemplate?.[1]?.link ?? "/"}
        style={{ order: Number(dataTemplate?.[1]?.positionInTemplate) }}
        className={`${twoBannerLink} pt-[25%] md:pt-[100%]`}
      >
        <Image
          priority
          fetchPriority="high"
          sizes="100vw"
          unoptimized
          src={dataTemplate?.[1]?.patchImage ?? "/images/default.png"}
          quality={100}
          width={5000}
          height={3000}
          className={twoBannerImageClass}
          alt="banner-2"
        />
        <span className={twoBannerParentSpan}>
          <span className={twoBannerSpan}>
            {dataTemplate?.[1]?.title}
            <ArrowLeft className={twoBannerArrow} />
          </span>
        </span>
      </Link>
    </div>
  );
}

export default TwoBannerTye6;
